<component
  v-if="shouldRenderConfig"
  v-bind:is="getContainerType"
  v-bind:class="getClassName"
>
  <appPageOptionAttributes
    v-for="(pageOptionAttributes,index) in getProductPageOptionValues"
    v-bind:key="index"
    v-bind:propsData="pageOptionAttributes"
  ></appPageOptionAttributes>
  <appInputCustomFormat
    v-if="code=='format'"
    v-bind:nrItems="getProductPageOptionValues.length"
  ></appInputCustomFormat>
</component>
